/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { Icon } from 'semantic-ui-react';
import * as R from 'ramda';

import AssignButtonActionDialogButton from '../dialogs/assign-button-action-dialog-button';
import { t } from '../../locales/i18n';
import { updateKioskAC } from '../../action-creators';
import KioskForm from '../forms/kiosk-form';
import EditItemDialog from '../dialogs/edit-item-dialog';
import { CardAttr } from '../widgets/card-attr';
import { KioskDeviceStatus } from '../kiosk-device-status';
import styled from 'styled-components';
import { colors } from '../../themes';
import formatLastSeenOnline from '../../utils/format-last-seen-online';
import { UnsupportedDeleteIcon } from './unsupported-delete-icon';

const Container = styled.div`
  padding: 1em;
  span.led,
  i.print {
    margin-right: 0.5em;
  }
  .button {
    padding: 4px;
    margin-right: 6px;
  }
  i.remove {
    color: ${colors.baseColors.red};
  }
`;

const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    margin-right: 0px;
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
  time {
    margin-right: 1em;
  }
  i.remove {
    margin-left: 2px;
  }
  .assign-buttons span {
    margin-right: 2px;
  }
`;

const AssignedButtonItem = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin-bottom: 8px;
  i {
    cursor: pointer;
  }
`;

function assignKioskAction(props: any, kioskAction: any) {
  const { dispatch, assignedButtons, id, controlBox } = props;
  const buttons = assignedButtons || [];
  buttons.push(kioskAction);
  const data = {
    id,
    controlBoxId: controlBox.id,
    assignedButtons: buttons
  };
  dispatch(updateKioskAC(data));
}

function removeKioskAction(props: any, buttonId: any) {
  const { dispatch, kioskId, buttons, controlBox } = props;
  const assignedButtons = R.reject(R.propEq(buttonId, 'id'))(buttons || []);
  const data = {
    id: kioskId,
    controlBoxId: controlBox.id,
    assignedButtons
  };
  dispatch(updateKioskAC(data));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function AssignedButton({ id, action, queueId, queues, serviceId, services, onClick, name }: any) {
  const queue = R.find(R.propEq(queueId, 'id'))(queues);
  const service = R.find(R.propEq(serviceId, 'id'))(services);
  return (
    <AssignedButtonItem key={id}>
      <div>
        <span>{id}</span>
        <span>{'\u2B95'}</span>
        <span>{queue && queue.name}</span>
        <span>{'\u2B95'}</span>
        <span>{service && service.name}</span>
        {name && <div>Name: {name}</div>}
      </div>
      <Icon
        name="remove circle"
        onClick={() => onClick(id)}
        // color="red"
        size="large"
      />
    </AssignedButtonItem>
  );
}

function KioskButton({ id }: any) {
  return <li key={id}> {id}</li>;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function KioskButtons(props: any) {
  if (!props.buttons || props.buttons.length === 0) {
    return <span>No button found for this kiosk. Try to connect it to QSRV ...</span>;
  }
  return (
    <ul>
      {props.buttons.map((b: any) => (
        <KioskButton key={b.id} {...b} />
      ))}
    </ul>
  );
}

function AssignedButtons(props: any) {
  function handleRemove(id: any) {
    const res = window.confirm(`Do you realy want to remove button ${id}?`);
    if (res) {
      removeKioskAction(props, id);
    }
  }
  if (!props.buttons || props.buttons.length === 0) {
    return <span>No button assigned yet ...</span>;
  }
  return (
    <div className="assign-buttons">
      {props.buttons.map((b: any) => (
        <AssignedButton
          onClick={(buttonId: any) => handleRemove(buttonId)}
          kioskId={props.kioskId}
          key={b.id}
          {...b}
          queues={props.queues}
          services={props.services}
        />
      ))}
    </div>
  );
}
export default function KioskCard(props: any) {
  return (
    <Container>
      <Header className="card-header">
        <h3>
          <Icon name="print" />

          <KioskDeviceStatus uuid={props.uuid} kioskType={props.kioskType} />
          <span>{props.uuid}</span>
        </h3>
        <Actions>
          <AssignButtonActionDialogButton
            buttonLabel={t('Assign Btn')}
            buttonDisabled={false}
            modalTitle={t('Assign Button')}
            modalSubtitle={t('Assign an action to a kiosk button')}
            onModalConfirm={(data: any) => assignKioskAction(props, data)}
            queues={props.queues}
            services={props.services}
          />
          <EditItemDialog form={KioskForm} {...props} />
          <UnsupportedDeleteIcon what="kiosk" />
        </Actions>
      </Header>
      <Content>
        <CardAttr title={t('Last seen online')}>{formatLastSeenOnline(props.lastSeenOnline)}</CardAttr>
        <CardAttr title="uuid">{props.uuid}</CardAttr>
        <CardAttr title="secret">{props.secret}</CardAttr>
        <CardAttr title="Kiosk Type">{props.kioskType}</CardAttr>
        <CardAttr title="Button Actions">
          <AssignedButtons
            controlBox={props.controlBox}
            queues={props.queues}
            services={props.services}
            buttons={props.assignedButtons}
            kioskId={props.id}
            dispatch={props.dispatch}
          />
        </CardAttr>
        <CardAttr title="Printer Code Page">{props.printer && props.printer.codePage}</CardAttr>
        <CardAttr title="CBX">{props.controlBox.uuid}</CardAttr>
        <CardAttr title="logoUrl">{props.logoUrl}</CardAttr>
        <CardAttr title="layoutName">{props.layoutName}</CardAttr>
        <CardAttr title="themeName">{props.themeName}</CardAttr>
      </Content>
    </Container>
  );
}
